import { configureStore } from '@reduxjs/toolkit'
import gameReducer from './game'
import uiReducer from './ui'
import socketReducer from './socket'

export default configureStore({
  reducer: {
    game: gameReducer,
    ui: uiReducer,
    socket: socketReducer,
  },
})
